import React from "react";
import PropTypes from "prop-types";
import "./engagementView.scss";

/**
 * Circular progress indicator component.
 * @parent component: EngagementCard
 * @author Bhavana
 */
const CircularProgress = ({
  progress,
  strokeColor = "#00aaff",
  size = 54,
  classProp = "circular-progress",
  progressClass = "project-allocation-circle",
  strokeWidth = 3.8,
  strokeWidthInner = 2,
  innerText,
  outerText,
  divClass = "d-flex flex-column justify-content-center align-items-center",
}) => {
  const text = innerText || `${progress}%`;
  return (
    <div className={`${divClass}`}>
      <div className={`${classProp}`}>
        <svg width={size} height={size} viewBox='0 0 36 36' className='circular-chart'>
          <path
            className='circle-bg'
            d='M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831'
            fill='none'
            stroke='#eee'
            strokeWidth={strokeWidthInner}
          />
          <path
            className={progressClass}
            strokeDasharray={`${progress}, 100`}
            d='M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831'
            fill='none'
            stroke={strokeColor}
            strokeWidth='2'
            strokeLinecap='round'
            style={{
              stroke: strokeColor,
              strokeWidth,
            }}
          />
          <text x='18' y='22' textAnchor='middle' className='project-allocation-percentage' fontSize='3px' fill='#000'>
            {text}
          </text>
        </svg>
      </div>
      {Boolean(outerText) && <span className='progress-text small'>{outerText}</span>}
    </div>
  );
};

CircularProgress.propTypes = {
  progress: PropTypes.number.isRequired,
  strokeColor: PropTypes.string,
  size: PropTypes.number,
  progressClass: PropTypes.string,
};

CircularProgress.defaultProps = {
  strokeColor: "#00f",
  size: 54,
};

export default CircularProgress;
